import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";

const EditCategoryDialog = ({ openEditDialog, handleCloseEditDialog, categoryName, setCategoryName, categoryHashtags, setCategoryHashtags, categoryLogo, setCategoryLogo, handleSaveEdit }) => (
      <Dialog open={openEditDialog} onClose={handleCloseEditDialog}>
        <DialogTitle>Edit Category</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Category Name"
            fullWidth
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Hashtags (comma separated)"
            fullWidth
            value={categoryHashtags}
            onChange={(e) => setCategoryHashtags(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Logo URL"
            fullWidth
            value={categoryLogo}
            onChange={(e) => setCategoryLogo(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditDialog}>Cancel</Button>
          <Button onClick={handleSaveEdit}>Save</Button>
        </DialogActions>
      </Dialog>
);

export default EditCategoryDialog;
